import { Injectable } from '@angular/core';
import { ContextService, XenaClient } from 'src/app/services';
import { Observable } from 'rxjs';
import { IFiscalSetup } from 'src/app/xena-api';


@Injectable({
  providedIn: 'root'
})
export class FiscalSetupService {

  constructor(
    private xenaClient: XenaClient,
    protected context: ContextService
  ) { }

  get(): Observable<IFiscalSetup> {
    const path: string = `/Fiscal/${this.context.fiscalId}/FiscalSetup`;
    return this.xenaClient.get<IFiscalSetup>(path);
  }

  create(fiscal: IFiscalSetup): Observable<IFiscalSetup> {
    const path: string = '/Home/FiscalSetup';
    return this.xenaClient.post<IFiscalSetup, IFiscalSetup>(path, fiscal);
  }
}
